import React from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { Box, Grid } from '@mui/material';
import { observer } from 'mobx-react';
import { useTheme } from '@mui/material/styles';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { ProfileStore } from '@gamiphy/loyalty-station-desktop/store/ui/profile';
import { useShowLevel, useShowProgress } from './hooks';
import HeaderProfileCard from './components/header/HeaderProfileCard';
import DraftUserHeader from './components/header/DraftUserHeader';

export type Props = {
  isBackButton: boolean,
  handleClick: () => void,
};

const ProfileCard: React.FC<Props> = observer(({ isBackButton, handleClick }) => {
  const { user } = UserStore;
  const { app } = AppStore;
  const theme = useTheme();

  // Assume mobile is false for now, or add logic if needed
  const mobile = false;
  const showLevel = useShowLevel(mobile);
  const showProgress = useShowProgress(mobile);

  const {
    width,
    height,
    ref,
  } = useResizeDetector();

  const header = React.useMemo(() => {
    switch (UserStore.isRealUser) {
      case true:
        return (
          <Grid container spacing={1}>
            <Grid size={12}>
              <HeaderProfileCard
                handleClick={handleClick}
                isBackButton={isBackButton}
                showLevel={showLevel}
                showProgress={showProgress}
              />
            </Grid>
          </Grid>
        );
      default:
        return <DraftUserHeader handleClick={handleClick} isBackButton={isBackButton} />;
    }
  }, [UserStore.isRealUser, showLevel, showProgress, isBackButton]);

  React.useEffect(() => {
    if (width && height) {
      ProfileStore.setDimensions({
        width,
        height,
      });
    }
  }, [height, width]);

  return (
    <div ref={ref}>
      {!user && app && theme ? null : (
        <Box
          sx={{
            background: theme?.palette?.primary?.main,
            padding: theme.spacing(1, 2),
            boxShadow: '0 3px 10px 0 rgba(0, 0, 0, 0.05)',
            zIndex: 9999,
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
          }}
        >
          {header}
        </Box>
      )}
    </div>
  );
});

export default ProfileCard;
